// components
import GridPageAbstract from '../abstract/GridPageAbstract';
import { mergeHeadWithStorage } from '../../utils/gridHeadStorage';

export default class SystemAccountsPage extends GridPageAbstract {
    constructor(props) {
        super(props);
        this.Name = 'accountingSystemAccounts';
        this.Server = this.props.context.getState().server.accountingSystemAccounts;
        this.MenuDisplayType = 'menu';
        this.searchFields = ['name'];

        const defaultHead = [
            { id: 'name', required: true, label: 'name', alignRight: false, cell: 'Text', displayGrid: true },
            { id: 'description', label: 'description', alignRight: false, cell: 'BigText', displayGrid: true },
            {
                id: 'currencyId',
                label: 'currency',
                alignRight: false,
                cell: 'Select',
                from: 'publicCurrencies',
                object: 'currency',
                show: 'code',
                displayGrid: true
            },
            // Reported by a balance sync, not entered by hand — the API rejects
            // them on a request now, and a typed value would be
            // indistinguishable from a real one. Still shown in the grid.
            { id: 'apiBalance', label: 'apiBalance', alignRight: true, cell: 'Amount', displayGrid: true, disableEditor: true },
            { id: 'apiSyncDate', label: 'apiSyncDate', alignRight: false, cell: 'DateTime', displayGrid: true, disableEditor: true },
            {
                id: 'modifiedReason',
                label: 'modifiedReason',
                alignRight: false,
                cell: 'BigText',
                displayGrid: true,
                disableEditor: true
            },
            {
                id: 'modifiedBy',
                label: 'modifiedBy',
                alignRight: false,
                cell: 'Select',
                object: 'modifiedBy',
                show: 'firstName+lastName',
                displayGrid: true,
                disableEditor: true,
                customSort: 'modifiedBy.firstName'
            },
            {
                id: 'dateCreatedModified',
                elements: ['dateCreated', 'dateModified'],
                label: 'dateCreatedModified',
                alignRight: false,
                cell: 'CreateModify',
                disableEditor: true,
                displayGrid: true,
                customSort: 'dateCreated'
            }
        ];
        this.Head = mergeHeadWithStorage(this.Name, defaultHead);

        this.state = {
            ...this.state,
            head: this.Head
        };
    }
}
